import { createContext, useContext } from 'react'

const ShipSamplesContext = createContext(null)

export function useShipSamplesContext() {
  const context = useContext(ShipSamplesContext)
  if (!context) {
    throw new Error('Empty context')
  }
  return context
}

export default ShipSamplesContext
